import { defineMessages } from "react-intl";

export const messages = defineMessages({
  successMessage: {
    id: "button.inviteUser.success",
    defaultMessage: "Successfully invited user",
    description: "success text",
  },
});
